<template>
  <transition name="fade" mode="out-in">
    <div v-if="isLoading" class="shimmer h-7 w-16 rounded-full" />
    <button
      v-else-if="!isError && cashbackPercent > 0"
      type="button"
      class="cashback-header-badge flex items-center gap-1 rounded-full px-2.5 py-1"
      v-bind="$attrs"
      @click="emit('onClick')"
    >
      <span class="text-static-white text-sm font-semibold">
        {{ cashbackPercent }}%
      </span>
      <img
        :src="cashbackShieldIcon"
        width="16"
        height="16"
        alt=""
        role="presentation"
      />
    </button>
  </transition>
</template>

<script setup lang="ts">
  const cashbackShieldIcon = new URL(
    '../assets/cashback-shield.svg',
    import.meta.url,
  ).href;

  defineProps<{
    cashbackPercent: number;
    isLoading: boolean;
    isError: boolean;
  }>();

  const emit = defineEmits<{
    onClick: [];
  }>();
</script>

<style scoped>
  .cashback-header-badge {
    background: linear-gradient(262.23deg, #01d58a -1.12%, #006fc2 101.31%);
  }
</style>
